import React, { useState } from 'react';

// Components
import { Grid } from '@mui/material';

// Custom components
import { SessionCheckConfigForm } from '../SessionCheckConfigForm';
import { PasswordPolicyForm } from '../PasswordPolicyForm';
import { AppearanceForm } from '../AppearanceForm';
import { TabPanel } from '../../components/atoms/tabPanel';
import { GeneralSettings } from '../../components/GeneralSettings';

// Services

// Styles
import { Container, PageTitle } from '../styles';
import { ContentCard, PageSubtitle, SectionPageTitle, SettingsTab, SettingsTabs } from './styles';

// Icons

// Utils
import { useTranslation } from 'react-i18next'
import { ColorsContext } from "../../Context/ColorsContext"

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../Context/PermissionsContext';
import { AccessTimeOutlined, PaletteOutlined, SettingsOutlined, ShieldOutlined } from '@mui/icons-material';

export const Settings = (props) => {
    const { t } = useTranslation();
	const { colors } = React.useContext(ColorsContext);
	const ability = useAbility(AbilityContext);

	const [tab, setTab] = useState(0)

    function handleChangeTab(_, value) {
		setTab(value);
    }


	return (
		<Container open={props.open}>
			
			<SectionPageTitle>
				<PageTitle>{t('settings.title')}</PageTitle>
				<PageSubtitle>{t('settings.subtitle')}</PageSubtitle>
			</SectionPageTitle>

			<Grid container mt={1} spacing={2}>
				<Grid item xs={12} lg={8} xl={7}>
					<SettingsTabs
						value={tab}
						onChange={handleChangeTab}
						textColor="secondary"
						indicatorColor="secondary"
						aria-label="secondary tabs example"
						variant="scrollable"
						allowScrollButtonsMobile={true}
						TabIndicatorProps={{style: {backgroundColor: colors.buttonActionColor, color: colors.buttonActionColor }}}
						sx={{
							"& .MuiTabs-scrollButtons.Mui-disabled": {
								opacity: 0,
								width: 0,
								minWidth: 0,
								padding: 0,
								margin: 0,
								overflow: "hidden",
							}
						}}
					>
						{ability.can("DefaultWorkflow") &&
							<SettingsTab value={0}
								selected={tab === 0}
								label={t('sidebar.system.settings')}
								icon={<SettingsOutlined/>}
								iconPosition="start"/>
						}
						{ability.can("UpdatePasswordPolicy") &&
							<SettingsTab value={1}
								selected={tab === 1}
								label={t('sidebar.system.passwordPolicy')}
								icon={<ShieldOutlined/>}
								iconPosition="start"/>
						}
						{ability.can("UpdateInactivityTime") &&
							<SettingsTab value={2}
								selected={tab === 2}
								label={t('sidebar.system.inactivityTimes')}
								icon={<AccessTimeOutlined/>}
								iconPosition="start"/>
						}
						{ability.can("UpdateAppearance") &&
							<SettingsTab value={3}
								selected={tab === 3}
								label={t('sidebar.system.appearance')}
								icon={<PaletteOutlined/>}
								iconPosition="start"/>
						}
					</SettingsTabs>
				</Grid>

				<Grid item xs={12}>
					{ability.can("DefaultWorkflow") &&
						<TabPanel value={tab} index={0} style={{ marginTop: 0 }}> 
							<ContentCard>
								<GeneralSettings/>
							</ContentCard>
						</TabPanel>
					}
					{ability.can("UpdatePasswordPolicy") &&
						<TabPanel value={tab} index={1} style={{ marginTop: 0 }}> 
							<ContentCard>
								<PasswordPolicyForm/>
							</ContentCard>
						</TabPanel>
					}
					{ability.can("UpdateInactivityTime") &&
						<TabPanel value={tab} index={2} style={{ marginTop: 0 }}> 
							<ContentCard>
								<SessionCheckConfigForm/>
							</ContentCard>
						</TabPanel>
					}
					{ability.can("UpdateAppearance") &&
						<TabPanel value={tab} index={3} style={{ marginTop: 0 }}> 
							<AppearanceForm/>
						</TabPanel>
					}
				</Grid>
			</Grid>

		</Container>
	)
}
